var React = require('react');

function ShapeNav (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M295,3.270602 C282.098508,4.76727442 268.28125,12.8159437 200.338867,10.3110609 C141.960937,10.3110609 107.746094,35.8452405 75.1035137,35.8452405 C42.0461992,35.8452405 17.0107828,33.0569357 -0.00273520286,27.480326 L-0.00173520286,0 L328.038436,0.000539105607 C318.769174,0.489702618 311.004034,1.41401079 295,3.270602 Z"}));
}

ShapeNav.defaultProps = {"width":"328px","viewBox":"0 0 328 36","version":"1.1","preserveAspectRatio":"none"};

module.exports = ShapeNav;

ShapeNav.default = ShapeNav;
